import { Dialog as MuiDialog } from '@material-ui/core';
import { colors, paddings, fonts, margins } from '~/layout';
import * as lib from '~/dependencies';

export const BoxLanguages = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${paddings.alternative}px;

  .loading {
    width: 15px!important;
    height: 15px!important;
    position: absolute;
    top: 30px;
    right: 20px;
  }

  h3 {
    font-size: ${fonts.default}px;
    color: ${colors.black};
    margin: ${margins.reset}px;
    font-weight: 300;
    margin-bottom: ${margins.default}px;
  }
`;

export const ListLanguages = lib.styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    height: 48px;
    background-color: ${colors.white02};
    border: 1px dotted ${colors.lightGray06};
    border-radius: 10px;
    padding-left: ${paddings.alternative}px;
    padding-right: ${paddings.alternative}px;
    margin-bottom: 5px;

    .active {
      color: ${colors.lightBlue};
    }
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      flex: 1;

      span {
        color: ${colors.black};

        &:first-child {
          text-transform: uppercase;
          font-size: ${fonts.default}px;
        }
        &:last-child {
          font-size: ${fonts.label}px;
          opacity: 0.5;
        }
      }
    }

    .icon {
      max-width: 25px;
    }

  }
`;

export const Dialog = lib.styled(MuiDialog)`
  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .MuiPaper-root {
    background-color: transparent;
  }

  .MuiPaper-elevation24 {
    box-shadow: none;
  }

  .MuiCircularProgress-colorPrimary {
    color: #29cf6a;
  }
`;
